const { m } = require('minthril');

let privacyOptOutAssetsLoaded = false;

function loadPrivacyOptOutAssets() {
  if (privacyOptOutAssetsLoaded) {
    window.optOutOnLoad?.();
    return;
  }

  privacyOptOutAssetsLoaded = true;

  const stylesheet = document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.href = 'https://cdn.shopify.com/shopifycloud/privacy-banner/data-sale-opt-out.css';
  document.head.appendChild(stylesheet);

  const optOutScript = document.createElement('script');
  optOutScript.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/data-sale-opt-out.js';
  optOutScript.onload = () => {
    const captchaScript = document.createElement('script');
    captchaScript.src = 'https://js.hcaptcha.com/1/api.js?onload=optOutOnLoad';
    captchaScript.defer = true;
    document.body.appendChild(captchaScript);
  };
  document.body.appendChild(optOutScript);
}

function PrivacyChoicesPage() {
  return {
    view: () => m('article.privacy-choices',
      m('header.privacy-choices__heading',
        m('p.products__eyebrow', 'Store information'),
        m('h1', 'Your Privacy Choices')
      ),
      m('div.privacy-choices__content',
        m('p', 'As described in our Privacy Policy, we collect personal information from your interactions with us and our website, including through cookies and similar technologies. We may also share this personal information with third parties, including advertising partners. We do this in order to show you ads on other websites that are more relevant to your interests and for other reasons outlined in our privacy policy.'),
        m('p', 'Sharing of personal information for targeted advertising based on your interaction on different websites may be considered “sales”, “sharing”, or “targeted advertising” under certain U.S. state privacy laws. Depending on where you live, you may have the right to opt out of these activities. If you would like to exercise this opt-out right, please follow the instructions below.'),
        m('p', 'If you visit our website with the Global Privacy Control opt-out preference signal enabled, depending on where you are, we will treat this as a request to opt out of activity that may be considered a “sale” or “sharing” of personal information or other uses that may be considered targeted advertising for the device and browser you used to visit our website.'),
        m('div#pc--optOutFormContainer', {
          'data-not-applicable': 'To opt out of the “sale” or “sharing” of your personal information collected using cookies and other device-based identifiers as described above, you must be browsing from one of the applicable US states referred to above.',
          'data-description': 'If you would like to opt out of activity that may be considered a “sale” or “share,” or “targeted advertising”, please submit your email.',
          'data-email-label': 'Email',
          'data-success': 'Opted-out successfully',
          'data-error': 'A problem occurred, try submitting your email again',
          'data-form-description': 'By clicking “opt out“, the browser on this device will be opted out of sharing personal data. If you select the checkbox and enter an email, the related customer account will also be opted out.',
          'data-form-email-label': 'Email',
          'data-form-opt-out-account-label': 'Don’t share data from my account (optional)',
          'data-form-button-text': 'Opt out',
          'data-form-opted-out': 'The browser on this device is opted out',
          'data-form-success': 'You have successfully opted out',
          'data-form-error': 'A problem occurred, please try again',
          oncreate: loadPrivacyOptOutAssets
        })
      )
    )
  };
}

module.exports = { PrivacyChoicesPage };
